import { AxiosReports, AxiosGlobalFilters, AxiosReportLas } from '../config';
import qs from 'qs';
import { applyArrayFilter } from 'utils/applyArrayFilter';

const FiltersService = {
  getActivityResponsibles: ({ companyId, unitId }) => {
    if (companyId && unitId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/responsaveistecnicos`,
        params: {
          unidadeId: unitId,
        },
        headers: {
          EmpresaId: companyId,
          UnidadeId: unitId,
        },
      });
    }
  },
  getActivityResponsiblesV2: ({ companyId, unitIds, unitGroupIds, unitSubgroupIds }) => {
    return AxiosReports({
      method: 'post',
      url: `/filters/${companyId}/activity-responsibles`,
      data: {
        unitIds,
        unitGroupIds,
        unitSubgroupIds,
      },
    });
  },
  getResponsibleARTCertificateDocuments: ({ companyId, unitId }) => {
    let ART_TYPE = 34;
    if (companyId && unitId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/documentos`,
        params: {
          unidadeId: unitId,
          tipoDocumentoId: ART_TYPE,
        },
        headers: {
          EmpresaId: companyId,
          UnidadeId: unitId,
        },
      });
    }
  },
  getResponsibleTRTCertificateDocuments: ({ companyId, unitId }) => {
    let TRT_TYPE = 35;
    if (companyId && unitId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/documentos`,
        params: {
          unidadeId: unitId,
          tipoDocumentoId: TRT_TYPE,
        },
        headers: {
          EmpresaId: companyId,
          UnidadeId: unitId,
        },
      });
    }
  },
  getDocuments: ({ companyId, unitId }) => {
    if (companyId && unitId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/documentos`,
        params: {
          unidadeId: unitId,
        },
        headers: {
          EmpresaId: companyId,
          UnidadeId: unitId,
        },
      });
    }
  },
  getSystems: ({ companyId, unitIds, unitGroupIds, unitSubgroupIds }) => {
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/V1/sistemas`,
        params: {
          unidadeId: unitIds,
          GrupoUnidadeId: unitGroupIds,
          SubGrupoUnidadeId: unitSubgroupIds,
        },
        headers: {
          empresaId: companyId,
        },
      });
    }
  },
  getPMOCActivitiesPlans: ({ companyId, unitId, systemIds }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/planosatividades/ativos`,
      params: {
        empresaId: companyId,
        sistemasIds: systemIds,
        unidadeId: unitId,
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    });
  },
  getPMOCActivitiesPlansCount: ({ companyId, unitId = undefined }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/planosatividades/ativos`,
      params: {
        empresaId: companyId,
        unidadeId: unitId,
      },
    });
  },
  getAuditActivities: ({ companyId, unitIds, unitGroupIds, unitSubgroupIds }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/audit-activities`,
        data: {
          unitIds,
          unitGroupIds,
          unitSubgroupIds,
        },
      });
    }
  },
  getOcurrenceStatus: ({ companyId }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/occurrence-status`,
      });
    }
  },
  getStates: ({ companyId, unitGroupIds, unitSubgroupIds }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/states`,
        data: {
          unitGroupIds,
          unitSubgroupIds,
        },
      });
    }
  },
  getEstadosAtivos: ({ EmpresaId, GrupoUnidadeId, SubGrupoUnidadeId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: 'v1/estados/ativos',
      params: {
        GrupoUnidadeId,
        SubGrupoUnidadeId,
      },
      headers: {
        EmpresaId,
      },
    });
  },
  getOcurrenceNumbers: ({ companyId }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/occurrence-numbers`,
      });
    }
  },
  getCorrectionStatus: ({ companyId, occurrenceStatusIds }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/correction-status`,
        data: {
          occurrenceStatusIds,
        },
      });
    }
  },
  getUnitGroups: ({ companyId }) => {
    if (companyId) {
      return AxiosGlobalFilters({
        // method: 'post',
        // url: `/filters/${companyId}/unit-groups`,
        // data: {
        //   ids,
        // },
        method: 'get',
        url: '/v1/gruposUnidades/ativas',
        headers: {
          empresaId: companyId,
        },
      });
    }
  },
  getUnitSubgroups: ({ companyId, unitGroupIds }) => {
    let grupoUnidade;
    let GrupoUnidadeIds;
    if (typeof unitGroupIds === 'number') {
      grupoUnidade = unitGroupIds;
    } else if (Array.isArray(unitGroupIds)) {
      GrupoUnidadeIds = unitGroupIds;
    } else if (typeof unitGroupIds === 'string' && unitGroupIds.length > 0) {
      grupoUnidade = Number(unitGroupIds);
    }
    const params = {
      GrupoUnidadeId: grupoUnidade,
      GrupoUnidadeIds,
      EmpresaId: companyId,
    };
    Object.keys(params).forEach(key => {
      if (params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: '/v1/subgruposunidades/ativas',
        params,
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
        headers: {
          EmpresaId: companyId,
        },
      });
    }
  },
  getUnits: ({ companyId, unitSubgroupIds, stateIds, unitGroupIds, citieId }) => {
    let subGrupo = null;
    let grupoUnidade = null;
    let GrupoUnidadeIds = null;
    let SubGrupoUnidadeIds = null;
    if (typeof unitGroupIds === 'number') {
      grupoUnidade = unitGroupIds;
    } else if (Array.isArray(unitGroupIds)) {
      GrupoUnidadeIds = unitGroupIds;
    }
    if (typeof unitSubgroupIds === 'number') {
      subGrupo = unitSubgroupIds;
    } else if (Array.isArray(unitSubgroupIds)) {
      SubGrupoUnidadeIds = unitSubgroupIds;
    } else {
      subGrupo = null;
      SubGrupoUnidadeIds = null;
    }
    const params = {
      grupoUnidadeId: grupoUnidade,
      GrupoUnidadeIds,
      SubGrupoUnidadeIds,
      empresaId: companyId,
      subGrupoUnidadeId: subGrupo,
      EstadoId: stateIds,
      CidadeId: citieId,
    };

    // Remove chaves com valor null ou undefined
    Object.keys(params).forEach(key => {
      if (params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: '/v1/unidades/ativas',
        params,
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
        headers: {
          EmpresaId: companyId,
        },
      });
    }
  },
  getOccurrenceStatus: ({ companyId }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/occurrence-status`,
      });
    }
  },
  getAreas: ({ companyId, ids, unitIds, providerIds, areaGroupIds, areaSubgroupIds }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/areas`,
        data: {
          ids,
          unitIds,
          providerIds,
          areaGroupIds,
          areaSubgroupIds,
        },
      });
    }
  },
  getAreasLh: ({ empresa, siteId, grupoAreaId, subGrupoAreaId }) => {
    return AxiosGlobalFilters({
      method: 'GET',
      url: 'v1/areas/ativas',
      params: {
        siteId,
        grupoAreaId,
        subGrupoAreaId,
      },
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresa,
      },
    });
  },
  getAreaGroups: ({ companyId, unitIds, providerIds, areaIds, areaSubgroupIds }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/area-groups`,
        data: { unitIds, providerIds, areaIds, areaSubgroupIds },
      });
    }
  },

  getAreaSubgroups: ({ companyId, unitIds, providerIds, areaIds, areaGroupIds }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/area-subgroups`,
        data: {
          unitIds,
          providerIds,
          areaIds,
          areaGroupIds,
        },
      });
    }
  },
  getEquipmentTypes: ({ companyId }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/equipment-types`,
      });
    }
  },
  getEquipmentTypesAvailibility: ({ EmpresaId, UnidadeId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/tiposequipamentos`,
      headers: {
        EmpresaId,
        UnidadeId,
      },
    });
  },
  getEquipmentGroup: ({ empresaId, unidadeId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/gruposEquipamentos/ativos?empresaId=${empresaId}&unidadeId=${unidadeId}`,
    });
  },
  getEquipments: ({
    companyId,
    unitIds,
    providerIds,
    areaGroupIds,
    areaSubgroupIds,
    areaIds,
    equipmentTypeIds,
    equipamentGroupId,
    companySystemsId,
  }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/equipments`,
        data: {
          unitIds,
          providerIds,
          areaGroupIds,
          areaSubgroupIds,
          areaIds,
          equipmentTypeIds,
          equipamentGroupId,
          companySystemsId,
        },
      });
    }
  },
  getEquipmentsLh: ({ empresa, SiteId, AreaId }) => {
    return AxiosGlobalFilters({
      method: 'GET',
      url: 'v1/equipamentos/ativos',
      params: {
        SiteId,
        AreaId,
      },
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresa,
      },
    });
  },
  getEquipamentosAtivos: ({
    pageSize = 20,
    pageIndex = 1,
    empresaId,
    siteId,
    fornecedoresIds,
    sistemaId,
    tipoEquipamentoId,
    grupoAreaId,
    subGrupoAreaIds,
    areaId,
    grupoEquipamentoId,
    planoAtividadeId,
    fornecedorId,
  }) => {
    const params = {
      PageSize: pageSize,
      PageIndex: pageIndex,
    };
    const headers = {
      EmpresaId: empresaId,
    };

    applyArrayFilter(params, siteId, 'SiteId');
    applyArrayFilter(params, fornecedoresIds, 'FornecedoresIds');
    if (sistemaId) params.SistemaId = sistemaId;
    if (tipoEquipamentoId) params.TipoEquipamentoId = tipoEquipamentoId;
    applyArrayFilter(params, grupoAreaId, 'GrupoAreaId');
    applyArrayFilter(params, subGrupoAreaIds, 'SubGrupoAreaId');
    applyArrayFilter(params, areaId, 'AreaId');
    applyArrayFilter(params, grupoEquipamentoId, 'GrupoEquipamentoId');
    applyArrayFilter(params, planoAtividadeId, 'PlanoAtividadeId');
    if (fornecedorId) params.FornecedorId = fornecedorId;

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/equipamentos/ativos',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      headers,
    });
  },

  getGruposEquipamentos: ({ empresaId, siteId, search, pageIndex = 1, pageSize = 1000 }) => {
    const params = {
      empresaId: empresaId,
      PageIndex: pageIndex,
      PageSize: pageSize,
    };

    applyArrayFilter(params, siteId, 'SiteId');
    if (search) params.Search = search;

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/gruposEquipamentos',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  },

  getTiposEquipamentos: ({ empresaId, unidadeId }) => {
    const headers = {
      EmpresaId: empresaId,
      UnidadeId: unidadeId,
    };

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/tiposequipamentos',
      headers,
    });
  },

  getGruposAreasAtivos: ({ empresaId, unidadeId, fornecedoresIds }) => {
    const params = {
      empresaId: empresaId,
      unidadeId: unidadeId,
    };
    const headers = {
      EmpresaId: empresaId,
      UnidadeId: unidadeId,
    };
    applyArrayFilter(params, fornecedoresIds, 'fornecedoresIds');

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/gruposareas/ativos',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      headers,
    });
  },

  getSubGruposAreasAtivos: ({ empresaId, unidadeId, grupoAreaId, fornecedoresIds }) => {
    const params = {
      empresaId: empresaId,
      unidadeId: unidadeId,
    };
    const headers = {
      EmpresaId: empresaId,
      UnidadeId: unidadeId,
    };
    if (grupoAreaId) params.grupoAreaId = grupoAreaId;
    applyArrayFilter(params, fornecedoresIds, 'fornecedoresIds');

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/subgruposareas/ativos',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      headers,
    });
  },

  getAreasAtivos: ({
    empresaId,
    siteId,
    fornecedoresIds,
    grupoAreaId,
    subGrupoAreaId,
    search,
    pageIndex = 1,
    pageSize = 1000,
    usuarioId,
    areaId,
    planoAtividadeId,
  }) => {
    const params = {
      pageSize: pageSize,
      pageIndex: pageIndex,
    };
    const headers = {
      EmpresaId: empresaId,
    };
    applyArrayFilter(params, siteId, 'SiteId');
    applyArrayFilter(params, fornecedoresIds, 'FornecedoresIds');

    applyArrayFilter(params, grupoAreaId, 'GrupoAreaId');
    applyArrayFilter(params, subGrupoAreaId, 'SubGrupoAreaId');

    if (search) params.Search = search;
    if (usuarioId) params.UsuarioId = usuarioId;
    applyArrayFilter(params, areaId, 'AreaId');
    applyArrayFilter(params, planoAtividadeId, 'PlanoAtividadesId');
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/areas/ativas',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      headers,
    });
  },

  getSlas: ({ companyId, unitIds }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/slas`,
        data: {
          unitIds,
        },
      });
    }
  },
  getPriorities: ({ companyId, unitIds }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/priorities`,
        data: {
          unitIds,
        },
      });
    }
  },
  getDepartments: ({ companyId, unitIds }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/departments`,
        data: {
          unitIds,
        },
      });
    }
  },
  getCompanyDepartments: ({ companyId }) => {
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/setores`,
        headers: {
          EmpresaId: companyId,
        },
      });
    }
  },
  getMaterials: ({ companyId }) => {
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/materiais`,
        headers: {
          EmpresaId: companyId,
        },
      });
    }
  },
  getCategories: ({ companyId }) => {
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/categorias`,
        headers: {
          EmpresaId: companyId,
        },
      });
    }
  },
  getMeasurementUnits: ({ companyId }) => {
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/UnidadesMedicoes`,
        headers: {
          EmpresaId: companyId,
        },
      });
    }
  },
  getMeasurementUnit: ({ companyId, id }) => {
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/UnidadesMedicoes?UnidadeMedicao=${id}`,
        headers: {
          EmpresaId: companyId,
        },
      });
    }
  },
  getProviders: ({ companyId, unitIds }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/providers`,
        data: {
          unitIds: [unitIds],
        },
      });
    }
  },
  getUsers: ({ companyId, unitIds, providerIds }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/users`,
        data: {
          unitIds,
          providerIds,
        },
      });
    }
  },
  docTypes: () => {
    return AxiosReportLas({
      method: 'get',
      url: '/v1/Documento/tipos',
      headers: {
        'content-type': 'application/json',
      },
    });
  },
  getUserLh: ({ empresaId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/usuarios',
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresaId,
      },
    });
  },
};

export { FiltersService };
